import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ModalDialogType } from 'src/app/@core/constants';
import { Loan } from 'src/app/models/loan';
import { CustomerLoansDetailComponent } from '../components/customer-loans-detail/customer-loans-detail.component';

@Injectable({
  providedIn: 'root'
})
export class CustomerLoansDetailModalService {


  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService) { }

  show(loan:Loan | undefined):void {
    this.modalRef = this.modalService.show(CustomerLoansDetailComponent,
      {
        ignoreBackdropClick: true,
        initialState:{
          loan
        },
        class:`modal-dialog ${ModalDialogType.PRIMARY} modal-lg`
      });
    // this.modalRef.content.taxExemption = taxExemption;
    // this.modalRef.content.reasonId = taxExemption.reason.code;
    // this.modalRef.content.confirmAction = confirmAction;
  }
}



